// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"dd36302a","685":"c213ee1b","836":"34aadd42","906":"b0075130"}[chunkId] + ".chunk.js";
};